import { render, staticRenderFns } from "./ModifyRiskRatingScorePopup.vue?vue&type=template&id=0cd08476&"
import script from "./ModifyRiskRatingScorePopup.vue?vue&type=script&lang=js&"
export * from "./ModifyRiskRatingScorePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports